import React, { Fragment, memo, useRef } from 'react';
import { Box, Button } from '@mui/material';
import MemeContent from './MemeContent';
import MemeReply from './MemeReply';
import { CommentType, PostType } from '../memeverse_types';
import { useLocation, useNavigate } from 'react-router-dom';

interface MemeProps {
  post: PostType;
  allComments?: Record<string, CommentType>;
  onReplyClick: (item: PostType | CommentType) => void;
}

const MemeInProfilePage: React.FC<MemeProps> = ({
  post,
  allComments,
  onReplyClick,
}) => {
  const commentLimit: number =
    post && post.images && post.images.filter((val) => !!val).length > 0
      ? JSON.parse(localStorage.getItem('comment_limit_image') || '2')
      : JSON.parse(localStorage.getItem('comment_limit_no_image') || '2');
  const mainMeme = useRef<HTMLDivElement>(null);

  const location = useLocation();
  const navigate = useNavigate();

  const MemoizedReply = memo(function MemoizedReply({
    commentId,
    show_typing,
  }: {
    commentId: string;
    show_typing: boolean;
  }) {
    return (
      <MemeReply
        key={`comment-${commentId}`}
        parentPostOrComment={post}
        reply={{ ...allComments[commentId], show_typing: show_typing }}
        showNested={false}
        shouldLimitLength={true}
        allComments={allComments}
        onReplyClick={onReplyClick}
      />
    );
  });

  if (!post) {
    // skip post if not found
    return <></>;
  }

  return (
    <Box
      ref={mainMeme}
      className='meme'
      sx={{
        width: '100%',
        maxWidth: '100dvw',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        px: { xs: 1.5, md: 0 },
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxHeight: '100%',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MemeContent
          post={post}
          shouldLimitImageHeight={true}
          commentLimit={commentLimit}
          onReplyClick={() => onReplyClick(post)}
        />
        {!!post.flat_comments_list &&
          !!commentLimit &&
          post.flat_comments_list.map((commentId, index) => {
            return !!allComments[commentId] &&
              index >= post.flat_comments_list.length - commentLimit ? (
              // <MemeReply
              //   key={`comment-${commentId}`}
              //   parentPostOrComment={post}
              //   reply={allComments[commentId]}
              //   showNested={false}
              //   shouldLimitLength={true}
              //   allComments={allComments}
              // /> :
              <MemoizedReply
                key={`comment-${commentId}`}
                commentId={commentId}
                show_typing={
                  index ===
                  Math.max(
                    post.comments_counts,
                    post.flat_comments_list.length
                  ) -
                    1
                }
              />
            ) : (
              // skip comment if not in allComments
              // skip comment if beyond comment limit
              <Box
                key={`comment-${commentId}`}
                className={
                  !allComments[commentId]
                    ? `not-found ${commentId}`
                    : `comment-limit-skipped ${commentId}`
                }
              >
                <Fragment key={`comment-${commentId}`} />
              </Box>
            );
          })}
        {!!post?.comments_counts && post.comments_counts > commentLimit && (
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
              pt: 1,
            }}
          >
            <Button
              variant='outlined'
              component='a'
              href={`/ask/post/${post.docId}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                navigate(`/ask/post/${post.docId}`, {
                  state: {
                    from: location.pathname,
                    scrollY:
                      document.getElementById('ask-scroll-box')?.scrollTop || 0,
                  },
                });
              }}
            >
              {`See all ${post.comments_counts} comments`}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MemeInProfilePage;
